// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list {
  display: flex;
  max-width: 1094px;
  margin: 0 auto;
}

.item-layout {
  width: 30%;
  margin-left: 40px;
  position: relative;
  text-align: center;
  height: 120px;
  /* background: #E3E8EC; */
}

.item-layout::after {
  transition: all 0.2s ease-in-out;
  content: "";
  position: absolute;
  display: inline-block;
  width: 40px;
  height: 2px;
  right: -40px;
  background: #e3e8ec;
  top: 50%;
  transform: translateY(100%);
}

.item-layout:nth-of-type(1) {
  margin-left: 0;
}
.item-layout:last-child::after {
  width: 0;
  height: 0;
  background-color: none;
}

.item-layout:nth-of-type(1)::after {
  /* border-left: 60px solid #F7F7F7; */
}

.item-layout-image {
  /* margin-top: -50px; */
  width: 50px;
  height: 50px;
  border-radius: 20px;
}

.animate {
  opacity: 0;
  transform: scale(0.25);
  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  animation: append-animate 0.6s ease-in-out forwards;
}

@keyframes append-animate {
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/shared/wizard/funnels-layout/funnel-item/funnel-item-info-popup/funnel-item-page/funnel-item-page.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;AACA;EACE,QAAQ;EACR,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,mDAAmD;EACnD,mDAAmD;AACrD;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,w6EAAw6E","sourcesContent":[".list {\n  display: flex;\n  max-width: 1094px;\n  margin: 0 auto;\n}\n\n.item-layout {\n  width: 30%;\n  margin-left: 40px;\n  position: relative;\n  text-align: center;\n  height: 120px;\n  /* background: #E3E8EC; */\n}\n\n.item-layout::after {\n  transition: all 0.2s ease-in-out;\n  content: \"\";\n  position: absolute;\n  display: inline-block;\n  width: 40px;\n  height: 2px;\n  right: -40px;\n  background: #e3e8ec;\n  top: 50%;\n  transform: translateY(100%);\n}\n\n.item-layout:nth-of-type(1) {\n  margin-left: 0;\n}\n.item-layout:last-child::after {\n  width: 0;\n  height: 0;\n  background-color: none;\n}\n\n.item-layout:nth-of-type(1)::after {\n  /* border-left: 60px solid #F7F7F7; */\n}\n\n.item-layout-image {\n  /* margin-top: -50px; */\n  width: 50px;\n  height: 50px;\n  border-radius: 20px;\n}\n\n.animate {\n  opacity: 0;\n  transform: scale(0.25);\n  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);\n  animation: append-animate 0.6s ease-in-out forwards;\n}\n\n@keyframes append-animate {\n  from {\n    transform: scale(0);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
